import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"

const Quill = ReactQuill.Quill
var Font: any = Quill.import("formats/font")
Font.whitelist = ["Roboto", "Raleway", "Montserrat", "Lato", "Rubik", "Open Sans", "Poppins", "Nunito", "Merriweather"]

Quill.register(Font, true)

export const CONFIG_QUILL_MODULE: any = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: Font.whitelist }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    ["link", "image"],
    [{ color: [] }, { background: [] }],
    ["clean"],
    [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
  ],
  clipboard: {
    matchVisual: false,
  },
  imageResize: {
    parchment: Quill.import("parchment"),
    modules: ["Resize", "DisplaySize"],
  },
}

export const CONFIG_QUILL_FORMAT = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
  "background",
  "align",
  "table",
]

export const CONFIG_QUILL_MODULE_TEXT: any = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: Font.whitelist }],
    [{ size: [] }],
    ["bold", "italic", "underline"],
    ["link", "image"],
    [{ color: [] }],
    [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
  ],
  clipboard: {
    matchVisual: false,
  },
  imageResize: {
    parchment: Quill.import("parchment"),
    modules: ["Resize", "DisplaySize"],
  },
}

export const CONFIG_QUILL_FORMAT_TEXT = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "link",
  "image",
  "color",
  "background",
  "align",
  "table",
]
